import { pr, theme } from "aaa";
import * as React from "react";
import { CardWithIcon } from "./CardWithIcon";

type IProps = {
    icon: string | React.ReactNode,
    text: string,
    checked: boolean,
    onClick: any,
    "aria-label"?: string,
};

export const CardWithIconAndText = ({
    icon,
    text,
    checked,
    onClick,
    "aria-label": ariaLabel,
}: IProps) => {
    const color = checked ? theme.customColors.georgeLightBlue : theme.customColors.georgeLightGrey;

    return (
        <CardWithIcon
            checked={checked}
            onClick={onClick}
            aria-label={ariaLabel}
            style={{ height: 135, width: 190 }}
            icon={(
                <div style={{ textAlign: "center" }}>
                    {typeof icon === "string" ? (
                        <pr.GeorgeIconWrapper
                            color={color}
                            size={48}
                            iconName={icon}
                        />) : icon}
                    <pr.P_14_CONTENT style={{ marginTop: theme.MARGIN_SMALL, userSelect: "none", color }} >
                        {text}
                    </pr.P_14_CONTENT>
                </div>
            )}
        />
    );
};


// WEBPACK FOOTER //
// ./src/components/common/CardWithIconAndText.tsx